import { useEffect, useState } from "react";

export default function AgeGate() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("rebelco_age_ok")) setOpen(true);
  }, []);
  if (!open) return null;
  return (
    <div data-testid="age-gate" className="fixed inset-0 z-[60] bg-[#050507]/95 backdrop-blur-xl flex items-center justify-center p-6">
      <div className="max-w-lg w-full glass hairline p-8 sm:p-10 fade-up text-center">
        <div className="eyebrow-lg">Age Verification</div>
        <h2 className="mt-6 h-editorial text-4xl sm:text-5xl">You must be <span className="italic-serif text-[#D4AF37]">21+</span> to enter.</h2>
        <p className="mt-6 text-sm text-zinc-400 leading-relaxed">
          A private space for adults 21+.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3">
          <button
            data-testid="age-gate-confirm-btn"
            onClick={() => { localStorage.setItem("rebelco_age_ok", "true"); setOpen(false); }}
            className="rc-btn-primary w-full sm:flex-1">I am 21 or older — Enter</button>
          <a href="https://www.google.com" data-testid="age-gate-exit-btn" className="rc-btn-ghost w-full sm:flex-1 text-center">Exit</a>
        </div>
        <p className="mt-6 text-[10px] text-zinc-500 font-mono-eyebrow uppercase tracking-[0.28em]">Private by design.</p>
      </div>
    </div>
  );
}
